import type { MotdChannel } from "./types.js";

/** Map DEPLOY_ENV / health.env to an MOTD channel. Prod and unknown → no MOTD. */
export function motdChannelForEnv(deployEnv: string | undefined): MotdChannel | null {
  const env = (deployEnv ?? "").toLowerCase();
  if (env === "staging" || env === "sandbox") return "staging";
  if (env === "dev" || env === "development" || env === "local") return "dev";
  return null;
}
